import { REHYDRATE } from "redux-persist/constants";
import { AuthService } from '../../services';
import { firebaseAuth } from '../../firebase';
export const SMS_VERIFICATION_SEND_REQUEST = 'SMS_VERIFICATION_SEND_REQUEST';
export const SMS_VERIFICATION_SEND_SUCCESS = 'SMS_VERIFICATION_SEND_SUCCESS';
export const SMS_VERIFICATION_SEND_FAILURE = 'SMS_VERIFICATION_SEND_FAILURE';

export const VALIDATE_VERIFICATION_CODE_REQUEST = 'VALIDATE_VERIFICATION_CODE_REQUEST';
export const VALIDATE_VERIFICATION_CODE_SUCCESS = 'VALIDATE_VERIFICATION_CODE_SUCCESS';
export const VALIDATE_VERIFICATION_CODE_FAILURE = 'VALIDATE_VERIFICATION_CODE_FAILURE';

export const AUTH_DELEGATION_REQUEST = 'AUTH_DELEGATION_REQUEST';
export const AUTH_DELEGATION_SUCCESS = 'AUTH_DELEGATION_SUCCESS';
export const AUTH_DELEGATION_FAILURE = 'AUTH_DELEGATION_FAILURE';

export const TRACK  = 'TRACK';
export const BAD_TRACK  = 'BAD_TRACK';

export const SIGN_OUT = 'SIGN_OUT';

export const INTRO_HIDE = 'INTRO_HIDE';
export const INTRO_SHOW = 'INTRO_SHOW';

export const USER_LOCATION_RECEIVED = 'USER_LOCATION_RECEIVED';
export const USER_HAVE_MOBILE_APP = 'USER_HAVE_MOBILE_APP';
export const CLEAR_ALL = 'CLEAR_ALL';
export const AUTH_SAVE_USER_DATA = 'AUTH_SAVE_USER_DATA';


export const sendVerificationSMS = (phoneNumber) => (dispatch) => {
    dispatch({type: SMS_VERIFICATION_SEND_REQUEST});
    AuthService.start(phoneNumber)
        .then((response) => {
            console.log(response, 'SMS_VERIFICATION_SEND_SUCCESS');
            // getMyUserInfo()
            dispatch({type: SMS_VERIFICATION_SEND_SUCCESS, payload: response});
        })
        .catch((response) => {
            dispatch({type: SMS_VERIFICATION_SEND_FAILURE, payload: response});
        });
};

export const validateVerificationCode = (phoneNumber, code) => (dispatch) => {
    dispatch({type: VALIDATE_VERIFICATION_CODE_REQUEST});
    AuthService.verify(phoneNumber, code)
        .then(async (response) => {
            if(typeof response.error !== 'undefined') {
                dispatch({type: VALIDATE_VERIFICATION_CODE_FAILURE, payload: response});
                return;
            }
            console.log(response, 'response - response - response');

           const userData = await AuthService.getProfileInfo(response.access_token);
            if (userData && userData.user_metadata && userData.user_metadata.displayName) {
                dispatch({type: VALIDATE_VERIFICATION_CODE_SUCCESS, payload: response});
                dispatch({type: USER_HAVE_MOBILE_APP, payload: true});
                dispatch({type: AUTH_DELEGATION_REQUEST});
                dispatch({type: AUTH_SAVE_USER_DATA, payload: userData});
                AuthService.getFirebaseToken(response.id_token)
                    .then((responseFirebaseToken) => {
                        dispatch({type: INTRO_SHOW});
                        firebaseAuth.signInWithCustomToken(responseFirebaseToken.idToken)
                            .then((response) => {
                                dispatch({type: AUTH_DELEGATION_SUCCESS, payload: responseFirebaseToken});
                            })
                    })
                    .catch((error) => {
                        dispatch({type: AUTH_DELEGATION_FAILURE, payload: error})
                    });
            } else {
                dispatch({type: USER_HAVE_MOBILE_APP, payload: false});
                dispatch({type: CLEAR_ALL});
                // dispatch({type: SMS_VERIFICATION_SEND_SUCCESS, payload: false});
            }

        });
};

export const getUserLocation = () => dispatch => {
  fetch("https://ipinfo.io/json").then((response)=>{
    dispatch({type: USER_LOCATION_RECEIVED, payload: response.json()});
  });
};

export const signOut = () => dispatch => {
  dispatch({type: SIGN_OUT});
  localStorage.clear();
};

export const introHide = () => dispatch => {
    dispatch({type: INTRO_HIDE});
};

export function track(title, props) {
  if (!title)
    return {
      type: BAD_TRACK,
      payload: { }
    };

  return {
    type: TRACK,
    payload: { title, props }
  };
}

export const haveMobileAppClear = () => (dispatch) => {
    dispatch({type: USER_HAVE_MOBILE_APP, payload: true});
};
